import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PrescribeClinicalProductSearchQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
}>;


export type PrescribeClinicalProductSearchQuery = { readonly __typename?: 'Query', readonly productSearch: ReadonlyArray<{ readonly __typename?: 'ProductSearchResult', readonly id: string, readonly title: string, readonly productType: Types.ProductType }> };

export type PrescribeClinicalProductSearchWithInventoryQueryVariables = Types.Exact<{
  searchTerm: Types.Scalars['String'];
  inventoryInput: Types.ClinicalProductInventorySummaryInput;
}>;


export type PrescribeClinicalProductSearchWithInventoryQuery = { readonly __typename?: 'Query', readonly productSearch: ReadonlyArray<{ readonly __typename?: 'ProductSearchResult', readonly id: string, readonly title: string, readonly productType: Types.ProductType, readonly inventory: { readonly __typename?: 'ExternalReferenceInventorySummary', readonly supplyLevel: Types.SupplyLevel, readonly quantity: number } }> };


export const PrescribeClinicalProductSearchDocument = gql`
    query prescribeClinicalProductSearch($searchTerm: String!) {
  productSearch(
    input: {searchTerm: $searchTerm, productTypes: [vmps, amps], active: true, size: 20}
  ) {
    id
    title
    productType
  }
}
    `;

/**
 * __usePrescribeClinicalProductSearchQuery__
 *
 * To run a query within a React component, call `usePrescribeClinicalProductSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrescribeClinicalProductSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrescribeClinicalProductSearchQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *   },
 * });
 */
export function usePrescribeClinicalProductSearchQuery(baseOptions: Apollo.QueryHookOptions<PrescribeClinicalProductSearchQuery, PrescribeClinicalProductSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrescribeClinicalProductSearchQuery, PrescribeClinicalProductSearchQueryVariables>(PrescribeClinicalProductSearchDocument, options);
      }
export function usePrescribeClinicalProductSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrescribeClinicalProductSearchQuery, PrescribeClinicalProductSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrescribeClinicalProductSearchQuery, PrescribeClinicalProductSearchQueryVariables>(PrescribeClinicalProductSearchDocument, options);
        }
export type PrescribeClinicalProductSearchQueryHookResult = ReturnType<typeof usePrescribeClinicalProductSearchQuery>;
export type PrescribeClinicalProductSearchLazyQueryHookResult = ReturnType<typeof usePrescribeClinicalProductSearchLazyQuery>;
export type PrescribeClinicalProductSearchQueryResult = Apollo.QueryResult<PrescribeClinicalProductSearchQuery, PrescribeClinicalProductSearchQueryVariables>;
export const PrescribeClinicalProductSearchWithInventoryDocument = gql`
    query prescribeClinicalProductSearchWithInventory($searchTerm: String!, $inventoryInput: ClinicalProductInventorySummaryInput!) {
  productSearch(
    input: {searchTerm: $searchTerm, productTypes: [vmps, amps], active: true, size: 20}
  ) {
    id
    title
    productType
    inventory(input: $inventoryInput) {
      supplyLevel
      quantity
    }
  }
}
    `;

/**
 * __usePrescribeClinicalProductSearchWithInventoryQuery__
 *
 * To run a query within a React component, call `usePrescribeClinicalProductSearchWithInventoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrescribeClinicalProductSearchWithInventoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrescribeClinicalProductSearchWithInventoryQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      inventoryInput: // value for 'inventoryInput'
 *   },
 * });
 */
export function usePrescribeClinicalProductSearchWithInventoryQuery(baseOptions: Apollo.QueryHookOptions<PrescribeClinicalProductSearchWithInventoryQuery, PrescribeClinicalProductSearchWithInventoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrescribeClinicalProductSearchWithInventoryQuery, PrescribeClinicalProductSearchWithInventoryQueryVariables>(PrescribeClinicalProductSearchWithInventoryDocument, options);
      }
export function usePrescribeClinicalProductSearchWithInventoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrescribeClinicalProductSearchWithInventoryQuery, PrescribeClinicalProductSearchWithInventoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrescribeClinicalProductSearchWithInventoryQuery, PrescribeClinicalProductSearchWithInventoryQueryVariables>(PrescribeClinicalProductSearchWithInventoryDocument, options);
        }
export type PrescribeClinicalProductSearchWithInventoryQueryHookResult = ReturnType<typeof usePrescribeClinicalProductSearchWithInventoryQuery>;
export type PrescribeClinicalProductSearchWithInventoryLazyQueryHookResult = ReturnType<typeof usePrescribeClinicalProductSearchWithInventoryLazyQuery>;
export type PrescribeClinicalProductSearchWithInventoryQueryResult = Apollo.QueryResult<PrescribeClinicalProductSearchWithInventoryQuery, PrescribeClinicalProductSearchWithInventoryQueryVariables>;